export const concatMessages = (m1, m2, separator) => `${m1}${separator}${m2}`

export const capitalizeText = text => (text ? `${text.charAt(0).toUpperCase()}${text.slice(1)}` : '')

export function formatarCelular(celular) {
  if (!celular) return null

  const celularSemCaracteresEspeciais = celular.replace(/\D/g, '')

  const pattern = /^(\d{2})(\d{1,5})(\d{4})$/
  const replacement = '($1) $2-$3'

  return celularSemCaracteresEspeciais.replace(pattern, replacement)
}

export function formatarCnpj(cnpj) {
  if (!cnpj) return null

  const cnpjSemCaracteresEspeciais = cnpj.replace(/\D/g, '')

  if (cnpjSemCaracteresEspeciais.length !== 14) return cnpj

  return cnpjSemCaracteresEspeciais.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
}

export function formatarCpf(cpf) {
  if (!cpf) return null

  const cpfSemCaracteresEspeciais = cpf.replace(/\D/g, '')

  if (cpfSemCaracteresEspeciais.length !== 11) {
    return 'CPF inválido'
  }

  return cpfSemCaracteresEspeciais.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}
